import { QueryKey, useQuery } from "@tanstack/react-query";
import { projectApi } from "../api/project";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useProjects = ({ searchKey, portfolioId, isPinned, isCompleted, quickFilters, phase_name, phase_type_id, page, limit, my_tasks }: { searchKey: string, portfolioId: string | undefined, isPinned: boolean, isCompleted: boolean, quickFilters: { region: string[] | null, programme: string[] | null, site: string[] | null, workstream: string[] | null, 'worktype-group': string[] | null, projectYear: string[] | null, stakeholder: string[] | null}, phase_name: string | null, phase_type_id: number | null, page: number, limit: number, my_tasks: boolean }) => {

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["project-listing", searchKey, portfolioId, isPinned, isCompleted, quickFilters['region'], quickFilters['programme'], quickFilters['site'], quickFilters['workstream'], quickFilters['worktype-group'], quickFilters['projectYear'], quickFilters['stakeholder'], phase_name, phase_type_id, page, limit, my_tasks] as QueryKey,
        queryFn: () => projectApi.fetchProjects({
            search_term: searchKey,
            portfolio_id: portfolioId,
            region_id: quickFilters["region"],
            programme_id: quickFilters["programme"],
            site_id: quickFilters["site"],
            workstream_id: quickFilters["workstream"],
            work_type_group_id: quickFilters["worktype-group"],
            project_year: quickFilters["projectYear"],
            stakeholder_id: quickFilters["stakeholder"],
            phase_name,
            phase_type_id,
            page,
            limit,
            assign_to_me: my_tasks,
            ...(isCompleted ? {} : { is_pinned: isPinned }),
            ...(isCompleted ? { status: 'completed' } : {}),
        }),
        enabled: phase_name !== null && phase_type_id !== null,
    });

    return {
        projectData: data?.data?.rows || [],
        isLoading,
        isError,
        pagination: data?.data?.pagination || {},
        refetch,
        removeCache: () => { queryClient.removeQueries({ queryKey: ["project-listing"] }); },
        removeCachePinned: () => { queryClient.removeQueries({ queryKey: ["project-listing"] }); },
        removeCacheUnpinned: () => { queryClient.removeQueries({ queryKey: ["project-listing"] }); }
    };

}